module.exports = __webpack_public_path__ + "static/media/R-360HD_CrossSection.f84f8a2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/en/R-360HD_CrossSection.png
// module id = 481
// module chunks = 0